import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import OptionsCard from "../../../Components/Card/AssetUI/OptionsCard";
import Editor from "../../../Components/UI/Editor";
import { Box, Typography } from "@mui/material";
import { unicodeToString } from "../../../Js/Common";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const NB = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([
          { text1: "" },
        ])
      );
      setCurrentIndexPlay(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill([
            { text1: "" },
          ])
        )
      );

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: "",
        isEvaluated: "pending",
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (text, index) => {
    if (!attempted) {
      let newArray = [...userAnswer];
      newArray[index] = [{ text1: text }];
      setUserAnswer([...newArray]);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div  >
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <Box>
              {item && item.media && (
                <OptionMedia
                  media={item.media}
                  isPlaying={currentIndexPlay[index]}
                  setPlayMode={(status, end) => {
                    setPlayMode(status, index, end);
                  }}
                  sx={{ margin : '4px'}}
                ></OptionMedia>
              )}
              {item.text && (
                <Typography
                  sx={{
                    pt: 1.5,
                    px: 2,
                    fontWeight: 500,
                    color: "primary.main",
                    fontSize: "1rem",
                    "@media (min-width:1636px)": { fontSize: "1.4rem" },
                  }}
                >
                  {unicodeToString(item.text)}
                </Typography>
              )}
              <Box sx={{ px: 2 }}>
                <Editor
                  change={(data) => {
                    updateUserAnswer(data, index);
                  }}
                  readOnly={attempted}
                ></Editor>
              </Box>
            </Box>
          );
        })}
    </div>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default NB;
